"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOCATION_COOKIE_FIELD_NAME = void 0;
exports.formatLocation = formatLocation;
exports.formatVenue = formatVenue;
exports.setUserLocationInCookies = exports.getUserLocationFromCookies = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _generalUtils = require("@stubhub/general-utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * --NOTE-- SH_USER_INFO is used to store Multiple user info, ensure to use helper to get the object before modifying it.
 *
 */

var LOCATION_COOKIE_FIELD_NAME = 'location';

/**
 * Convert a catelog location object to a dispay string.
 * @param loc catalog location object, usually obtained via search location API
 *
 * Location display based on location + country.
 * if searching from US
 *  `Paris` should give me a list
 *     1. Paris, France
 *     2. Paris, TN
 *    3. Paris, FL
 *
 *   if searching from Europe
 *   `Paris` should give me a list
 *   1. Paris, France
 *   2. Paris, TN, United States
 *   3. Paris, FL, United States
 */

/**
 *{
 *'short': {
 *  'NorAm-inNorAm': '{city}, {stateCode}',
 *  'NorAm-inIntl': '{city}, {country}',
 *  'Intl':  '{city}, {country}'
 *},
 *'medium': {
 *  'NorAm-inNorAm': '{city}, {stateCode}',
 *  'NorAm-inIntl': '{city}, {stateCode}, {countryCode}',
 *  'Intl': '{city}, {stateCode}, {countryCode}'
 *},
 *'full': '{city}, {stateCode}, {countryCode}'
 *}
 */
exports.LOCATION_COOKIE_FIELD_NAME = LOCATION_COOKIE_FIELD_NAME;
function formatLocation(loc) {
  var currentCountryCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'US';
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'short';
  if (!loc) {
    return '';
  }
  if (format === 'full') {
    return "".concat(loc.city, ", ").concat(loc.stateCode, ", ").concat(loc.countryCode);
  }
  if (isIntl(loc.countryCode) || isIntl(currentCountryCode)) {
    if (format === 'short') {
      return "".concat(loc.city, ", ").concat(loc.country);
    }
    return "".concat(loc.city, ", ").concat(loc.stateCode, ", ").concat(loc.countryCode);
  }
  return "".concat(loc.city, ", ").concat(loc.stateCode);
}

/**
 * Venue usually does not have stateCode and countryCode
 */
function formatVenue(loc, currentCountryCode, format) {
  var venue = _objectSpread(_objectSpread({}, loc), {}, {
    countryCode: loc.country,
    stateCode: loc.state
  });
  return formatLocation(venue, currentCountryCode, format);
}

// TODO: remove hard code for 'US' and 'CA'
function isIntl(countryCode) {
  return countryCode !== 'US' && countryCode !== 'CA';
}

/**
 * Method to Set the User's location in the Cookies
 * @param cookies [object] CookieServer Or CookiesClient Instance to Write/Read Cookies Isomorphically.
 * @param userLocation [object] User Location Object from the Search Location API.
 * @returns shUserInfoCookie [object] The User Info Cookie Object.
 *
 */
var setUserLocationInCookies = function setUserLocationInCookies(cookies, userLocation) {
  if (userLocation) {
    var userInfoCookie = (0, _generalUtils.getUserInfoFromRequestCookies)(cookies);
    userInfoCookie[LOCATION_COOKIE_FIELD_NAME] = userLocation;
    var expirationPeriod = _generalUtils.TIME.DAYS_OF_YEAR * _generalUtils.TIME.HOURS_OF_DAY * _generalUtils.TIME.MINS_OF_HOUR * _generalUtils.TIME.SECONDS_OF_MIN * _generalUtils.TIME.MILLIS_OF_SECOND; // 1 year
    (0, _generalUtils.setUserInfoFromRequestCookies)(cookies, userInfoCookie, expirationPeriod);
  }
};

/**
 * Method to get the User Location from Cookies.
 * @param cookies [object] CookieServer Or CookiesClient Instance to Write/Read Cookies Isomorphically.
 * @returns locationCookie [object] The location cookie object.
 *
 */
exports.setUserLocationInCookies = setUserLocationInCookies;
var getUserLocationFromCookies = function getUserLocationFromCookies(cookies) {
  var shUserInfo = (0, _generalUtils.getUserInfoFromRequestCookies)(cookies);
  return shUserInfo[LOCATION_COOKIE_FIELD_NAME];
};
exports.getUserLocationFromCookies = getUserLocationFromCookies;